import type { ILiveKitRtcStats, IRtcStats } from 'vcs-common';

let lastStats: IRtcStats | null = null;
const HISTORY_WINDOW_MS = 15_000;

export type SupportRtcStatsSample = {
  collectedAt: number;
  report: IRtcStats;
};

let history: SupportRtcStatsSample[] = [];

export function setSupportRtcStats(report: IRtcStats) {
  lastStats = report;
  const collectedAt = Date.now();
  history = [...history, { collectedAt, report }].filter(
    (sample) => sample.collectedAt >= collectedAt - HISTORY_WINDOW_MS,
  );
}

export function getSupportRtcStats(): IRtcStats | null {
  return lastStats;
}

export function getSupportRtcStatsHistory(): SupportRtcStatsSample[] {
  const cutoff = Date.now() - HISTORY_WINDOW_MS;
  history = history.filter((sample) => sample.collectedAt >= cutoff);
  return [...history];
}

// `serverType` is a single literal in vcs-common, not a union, so comparing it does not narrow the type.
export const isLiveKitStats = (report: IRtcStats): report is ILiveKitRtcStats => report.serverType === 'livekit';

export function getSupportLiveKitStats(): ILiveKitRtcStats | null {
  return lastStats && isLiveKitStats(lastStats) ? lastStats : null;
}
